import { useQuery } from "@tanstack/react-query";
import DocumentsService from "../../services/DocumentsService";

const useRelatedDocuments = ({
  estateId,
  documentTypes,
  startDate,
  endDate,
  isCreated = false,
  withNoInformation = false,
  withContent,
}) => {
  return useQuery({
    initialData: [],
    queryKey: [
      "related-documents",
      estateId,
      documentTypes,
      startDate,
      endDate,
      isCreated,
      withNoInformation,
      withContent,
    ],
    queryFn: async () => {
      const data = await DocumentsService.getRelatedDocuments({
        estateId,
        documentTypes,
        startDate,
        endDate,
        isCreated,
        withNoInformation,
        withContent,
      });
      return data.data;
    },
  });
};

export default useRelatedDocuments;
